
// export const LOGOUT_REQUEST = "LOGOUT_REQUEST";


// export const logout_request_Success = (payload) => ({
//     type: LOGOUT_REQUEST,
//     payload
// })

export const PROFILE_DATA = "PROFILE_DATA";


export const profile_data_Success = (payload) => ({
    type: PROFILE_DATA,
    payload
})

